<nav class="navbar fixed-bottom navbar-light bg-white border-top border py-0">
  <!-- Nav Bar for Desktop -->
  <div class="container p-0 width__menu__line">
    <div class="d-flex footer-buttons left">
      <button type="button" id="report-back-btn" class="button ghost__button large__button w-100 d-flex justify-content-between"
        (click)="backButtonClick()" [disabled]="!backBtnEnable">
        <svg-icon name="caret-left" svgClass="mr-3"></svg-icon>
        {{backBtnText}}
      </button>
      <ng-container *ngIf="currentReport?.LATEST">
        <app-notes [reportVersionId]="currentReport.LATEST.ID" [pageId]="pageId"></app-notes>
      </ng-container>
    </div>

    <div class="d-flex h-100"
      [ngClass]="extraAvailable && skipAvailable ? 'w-60' : extraAvailable || skipAvailable ? 'w-40' : 'go-to-dashboard-width'">
      <button class="button white__button large__button w-100 d-flex justify-content-between" id="report-footer-extra-btn" *ngIf="extraAvailable"
        (click)="extraButtonClick()" [disabled]="extraBtnDisabled">
        {{extraBtnText}}
      </button>

      <button class="button secondary__button large__button icon__right w-100 d-flex justify-content-between"
        *ngIf="skipAvailable" id="report-footer-skip-btn" (click)="skipButtonClick()">
        {{skipBtnText}}
        <div class="d-flex" *ngIf="skipArrow">
          <svg-icon name="blue-caret-right"></svg-icon>
          <svg-icon name="blue-caret-right"></svg-icon>
        </div>
      </button>

      <button type="button"
        class="button primary__button large__button icon__right w-100 d-flex justify-content-between" id="report-next-btn"
        (click)="nextButtonClick()" [disabled]="!nextBtnEnable">
        {{nextBtnText}}
        <img src="../../../../../assets/images/caret-right.svg" alt="...">
      </button>
    </div>
  </div>

  <!-- Nav Bar for Mobile -->
  <div class="container p-0 mobile-bottom-menu">
    <!-- Back -->
    <button type="button" id="report-back-btn-mobile" class="button ghost__button mobile-nav-btn"
            (click)="backButtonClick()" [disabled]="!backBtnEnable">
      <svg-icon name="caret-left"></svg-icon>
      <span>{{backBtnText}}</span>
    </button>

    <!-- Notes -->
    <ng-container *ngIf="currentReport?.LATEST">
      <app-notes [notesButtonClass]="'mobile-nav-btn'" [reportVersionId]="currentReport.LATEST.ID" [pageId]="pageId"></app-notes>
    </ng-container>

    <!-- Extra -->
    <button type="button" class="button white__button mobile-nav-btn" id="report-footer-extra-btn-mobile"
            *ngIf="extraAvailable" (click)="extraButtonClick()" [disabled]="extraBtnDisabled">
      <svg-icon [name]="mobileIcon"></svg-icon>
      <span>{{extraBtnText}}</span>
    </button>

    <!-- Skip -->
    <button type="button" class="button white__button mobile-nav-btn" id="report-footer-skip-btn-mobile"
            *ngIf="skipAvailable" (click)="skipButtonClick()">
      <svg-icon [name]="mobileIcon"></svg-icon>
      <span>{{skipBtnText}}</span>
    </button>

    <!-- Next -->
    <button type="button" class="button primary__button mobile-nav-btn" id="report-next-btn-mobile"
            (click)="nextButtonClick()" [disabled]="!nextBtnEnable">
      <svg-icon name="white-caret-right"></svg-icon>
      <span>{{nextBtnText}}</span>
    </button>
  </div>
</nav>
